<app-page-shell [title]="'dashboard_title' | translate" [description]="'dashboard_desc' | translate" [card]="false">
  <button actions type="button" (click)="refresh()" [disabled]="loading()"
    class="ml-auto sm:ml-0 w-10 h-10 rounded-full bg-white border border-slate-200 shadow-sm flex items-center justify-center text-slate-500 hover:text-primary hover:border-primary transition-colors disabled:opacity-60"
    [attr.aria-label]="'dash_refresh' | translate" [title]="'dash_refresh' | translate">
    <i class="pi pi-refresh" [class.pi-spin]="loading()"></i>
  </button>
  <ng-container *ngIf="canAccessDashboard$ | async; else noPermission">
    <div *ngIf="error()" class="bg-red-50 text-red-700 rounded-2xl p-4 text-sm mb-4">{{ 'dash_error' | translate }}</div>

    <div *ngIf="loading() && !hasData()" class="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <div *ngFor="let i of [1, 2, 3, 4]" class="animate-pulse h-24 bg-slate-100 rounded-3xl"></div>
    </div>

    <ng-container [ngSwitch]="view()">
      <app-dash-owner-view *ngSwitchCase="'owner'" [data]="owner()!" [finance]="ownerFinance()" [statusPeriod]="statusPeriod()" [statusBreakdown]="statusBreakdown()" [statusLoading]="statusLoading()" (statusPeriodChange)="onStatusPeriodChange($event)" [onlineUsers]="onlineUsers$ | async" />
      <app-dash-doctor-view *ngSwitchCase="'doctor'" [data]="doctor()!" />
      <app-dash-staff-view *ngSwitchCase="'staff'" [data]="staff()!" />
    </ng-container>
  </ng-container>

  <ng-template #noPermission>
    <app-no-permission></app-no-permission>
  </ng-template>
</app-page-shell>
